import { PeopleInfoAddress } from "./peopleInfo-address.model";
import { PeopleInfoTelephone } from "./peopleInfo-telephone.model";
import { PeopleInfoRelated } from "./peopleInfo-related.model";
import { Lookup } from "./lookup.model";
import { EntityBase } from "./entity-base.model";
import { Party } from "src/app/frontoffice/parties/model/party.model";
export class PeopleInfo extends EntityBase {
  public NUmber?: number;
  public PartyId: number;
  public PersonalityKindId: number;
  public CompanyKindId?: number;
  public Title: string;
  public Number?: number;
  public Description: string;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public Comment: string;
  public Telephone: string;
  public MobileNumber: string;
  public Internalphone: string;
  public Post: string;
  public CompanyName: string;
  public PersonalityKindTitle: string;
  public PersonalityKindCode: number;
  public InformationKindTitle: string;
  public InformationKindCode: number;
  public CompanyKindTitle: string;
  public CompanyKindCode?: number;
  public PersonalityKind: Lookup;
  public PeopleInfoAddresss: PeopleInfoAddress[];
  public PeopleInfoTelephones: PeopleInfoTelephone[];
  public PeopleInfoRelateds: PeopleInfoRelated[];
  public DetailLedgerId?: number;
  public DetailLedgerCode?: number;
  public NationalCode: string;
  public EconomicCode: string;
  public RegistrationNumber: string;
  public BrandName: string;
  public CityName: string;
  public CityId?: number;
  public Party: Party;
  public IsCustomer: boolean;
  public IsSupplier: boolean;
  public IsEmployee: boolean;
  public IsBroker: boolean;
  public IsDetailLedger: boolean;
  public DetailLedgerKindId?: number;
  public DetailLedgerKindCode?: number;
  public DetailLedgerKindTitle: string;
  public StartCode?: number;
  public EndCode?: number;
  public ContactKindByEmail: boolean;
  public ContactKindBySMS: boolean;
  public ContactKindByTelegram: boolean;
  public ResellerFirstName: string;
  public ResellerId?: number;
  public ResellerLastName: string;
  public ResellerCompanyName: string;
  public ShamsiCreationDate: string;
  public CustomerComment: string;
  public UserId?: number;
  public UserDisplayName: string;
}
